import React from 'react';
import { createPortal } from 'react-dom';
import { IDIOMAS_NORMATIVA } from '../../utils/normativaIdioma';

// Ventanita «¿En qué idioma imprimo la normativa?» (Ann 2026-09-10).
// Portal a <body>: así se ve bien aunque se abra desde dentro de otro modal.
export default function ElegirIdiomaNormativa({ abierto, idiomas, inicial, onElegir, onCancelar }) {
  const [lang, setLang] = React.useState(inicial);
  React.useEffect(() => { if (abierto) setLang(inicial); }, [abierto, inicial]);
  React.useEffect(() => {
    if (!abierto) return undefined;
    const tecla = (e) => { if (e.key === 'Escape') onCancelar(); };
    window.addEventListener('keydown', tecla);
    return () => window.removeEventListener('keydown', tecla);
  }, [abierto, onCancelar]);
  if (!abierto) return null;

  const btn = { fontSize: 12, fontWeight: 600, padding: '7px 16px', borderRadius: 3, cursor: 'pointer' };
  return createPortal(
    <div data-testid="elegir-idioma-normativa" onClick={onCancelar} style={{
      position: 'fixed', inset: 0, zIndex: 10000, background: 'rgba(15,23,42,0.45)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div role="dialog" aria-modal="true" aria-labelledby="elegir-idioma-titulo" onClick={(e) => e.stopPropagation()} style={{
        background: '#fff', borderRadius: 6, padding: '20px 22px', width: 320, maxWidth: '90vw',
        boxShadow: '0 10px 30px rgba(15,23,42,0.2)', fontFamily: "'Inter', system-ui, sans-serif",
      }}>
        <h3 id="elegir-idioma-titulo" style={{ margin: '0 0 4px', fontSize: 15, color: '#1e293b' }}>
          ¿En qué idioma imprimo la normativa?
        </h3>
        <p style={{ margin: '0 0 14px', fontSize: 12, color: '#64748b' }}>
          Viene marcado el idioma que el cliente tiene en su plataforma.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 18 }}>
          {idiomas.map((l) => (
            <label key={l} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#1e293b', cursor: 'pointer' }}>
              <input type="radio" name="idioma-normativa" value={l} checked={lang === l}
                onChange={() => setLang(l)} style={{ accentColor: '#1e293b' }} />
              {IDIOMAS_NORMATIVA[l] || l}
            </label>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button type="button" onClick={onCancelar}
            style={{ ...btn, border: '1px solid #e8ecf1', background: '#fff', color: '#1e293b' }}>Cancelar</button>
          <button type="button" autoFocus onClick={() => onElegir(lang)}
            style={{ ...btn, border: '1px solid #1e293b', background: '#1e293b', color: '#fff' }}>Imprimir</button>
        </div>
      </div>
    </div>,
    document.body
  );
}
